import { useMemo, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

import PtHeader from "./preguntasTalento/PtHeader";
import PtTabPorTalento from "./preguntasTalento/PtTabPorTalento";
import PtTabPorFortaleza from "./preguntasTalento/PtTabPorFortaleza";

// Reutilizamos los estilos del summary de confirmación para consistencia
// y añadimos solo las piezas específicas del nuevo quiz (Sí/No).
import "./css/confirmacionSummary.css";
import "./css/preguntasTalentoSummary.css";

const TABS = [
  { key: "talento", label: "Por Talento", icon: "mdi:star-outline" },
  { key: "fortaleza", label: "Por Fortaleza", icon: "mdi:target" },
];

const PreguntasTalentoSummary = ({ summary }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("talento");

  const preguntas = summary?.preguntas_talento || [];

  const { totalRespuestas, totalSi, totalFortalezas } = useMemo(() => {
    let total = 0;
    let si = 0;
    preguntas.forEach((g) => {
      (g.talentos || []).forEach((t) => {
        (t.respuestas || []).forEach((r) => {
          total += 1;
          if (r.valor) si += 1;
        });
      });
    });
    return { totalRespuestas: total, totalSi: si, totalFortalezas: preguntas.length };
  }, [preguntas]);

  if (preguntas.length === 0) {
    return (
      <div className="card radius-12">
        <div className="card-body p-24 text-center">
          <Icon
            icon="mdi:comment-question-outline"
            className="text-6xl text-neutral-300 mb-3"
          />
          <h5 className="text-neutral-600">No hay respuestas registradas</h5>
          <p className="text-neutral-500">
            Aún no has respondido ninguna afirmación.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-12">
        <PtHeader
          totalRespuestas={totalRespuestas}
          totalSi={totalSi}
          totalFortalezas={totalFortalezas}
        />

        <motion.div
          className="cs-main-tabs-wrap mb-20"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.4 }}
        >
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`cs-main-tab-btn ${
                activeTab === tab.key ? "active" : ""
              }`}
              onClick={() => setActiveTab(tab.key)}
              type="button"
            >
              <Icon icon={tab.icon} />
              {tab.label}
            </button>
          ))}
        </motion.div>

        <AnimatePresence mode="wait">
          {activeTab === "talento" && (
            <motion.div
              key="tab-talento"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.25 }}
            >
              <PtTabPorTalento preguntas={preguntas} />
            </motion.div>
          )}

          {activeTab === "fortaleza" && (
            <motion.div
              key="tab-fortaleza"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.25 }}
            >
              <PtTabPorFortaleza preguntas={preguntas} />
            </motion.div>
          )}
        </AnimatePresence>

        <motion.div
          className="d-flex justify-content-center mt-4 mb-3 px-3"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.4 }}
        >
          <button
            type="button"
            onClick={() => navigate("/mis-talentos")}
            className="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2 rounded-pill shadow-sm w-100 w-sm-auto"
            style={{
              maxWidth: 420,
              minHeight: 44,
              padding: "0.65rem 1.5rem",
              fontSize: "clamp(0.85rem, 2.4vw, 1rem)",
              lineHeight: 1.25,
              textAlign: "center",
            }}
          >
            <Icon icon="mdi:arrow-right-circle" width="20" />
            Ir a mis talentos
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default PreguntasTalentoSummary;
